import React from "react";
import { Link } from "react-router-dom";
import { getPublicUrl } from "../../helpers/helper_functions";
import "./Oops.css";

const Oops = () => {
  return (
    <div className="oops-page">
      <div className="oops-content">
        <div className="oops-image-container">
          <img
            src={getPublicUrl("/assets/oopscow.png")}
            alt="Cow"
            className="oops-cow-image"
          />
        </div>
        <h1 className="oops-title">Got milk?</h1>
        <h2 className="oops-subtitle">We don't.</h2>
        <p className="oops-message">Let's go back home buddy!</p>
        <Link to="/" className="oops-home-button">
          Take Me Home
        </Link>
      </div>
    </div>
  );
};

export default Oops;
